import { Validators } from '@angular/forms';
import { isChipId, isVin } from '../../../common/helpers/validators';

export class VehicleModel {
  /**
   *@var error to store error status
   **/
  public error: any;
  /**
   *@var vin to store vin
   **/
  public vin: string;
  /**
   *@var chipId to store chip-id
   **/
  public chipId: string;
  /**
   *@var searchType to store the type of search (vin or chipId)
   **/
  public searchType: 'vin' | 'chipId' | 'imei';
  /**
   *@var vehicleDetails to store vehicles
   **/
  public vehicleDetails;
  /**
| * Mapping of brand initials to their full and short names.
| * @constant {Object.<string, {full: string, short: string}>}
| */
  public  BRAND_MAP = {
  t: { full: 'TOYOTA', short: 'T' },
  s: { full: 'SUBARU', short: 'S' },
  l: { full: 'LEXUS', short: 'L' }
};
  constructor(searchValue: string) {
    if (isVin(searchValue)) {
      this.vin = searchValue;
      this.searchType = 'vin';
    } else if (isChipId(searchValue)) {
      this.chipId = searchValue;
      this.searchType = 'chipId';
    } else {
      this.vin = searchValue;
      this.searchType = 'imei';
    }
  }
  
  /**
   * Get the search value (VIN or Chip-ID)
   */
  public getSearchValue(): string {
    return this.searchType === 'chipId' ? this.chipId : this.vin;
  }
  
  /**
   * Check if search is by chip-id
   */
  public isChipIdSearch(): boolean {
    return this.searchType === 'chipId';
  }
  
  /**
   * getRouteParams Returns the params for vin list by vin
   **/
  get getVinlistParams(): object {
    return this.vehicleDetails;
  }

/**
| * Returns the vehicle brand name based on the vehicle data and flag.
| *
| * @param {Object} vehicle - The vehicle object containing brand information.
| * @param {string} [vehicle.brand] - The brand name string.
| * @param {string} [vehicle.brandCode] - The brand code string.
| * @param {boolean} isHucomflag - Flag to determine if short or full brand name is returned.
| * @returns {string} The brand name (full or short) or 'Brand N/A' if unknown or missing.
| */
public getVehicleBrand(vehicle: any, isHucomflag: boolean): string {
  if (!vehicle) {
    return 'Brand N/A';
  }
  const brandChar = (vehicle.brand && vehicle.brand[0].toLowerCase()) ||
                    (vehicle.brandCode && vehicle.brandCode[0].toLowerCase());
  const brand = this.BRAND_MAP[brandChar];
  return brand ? (isHucomflag ? brand.short : brand.full) : 'Brand N/A';
}
}
